module.exports = __webpack_public_path__ + "static/media/success-bg.59335ed4.jpg";